import { useEffect, useState, useCallback, useMemo } from 'react';
import PropTypes, { object } from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { useField, useFormikContext } from 'formik';
import classNames from 'classnames';
import _noop from 'lodash/noop';
import Rating from 'react-rating';
import { Input, ResponseModal, Card, Select, ImageGallery, ControltQuantity } from 'components';
import { useWindowSize } from 'hooks';
import { withStore } from 'store';
import successIcon from 'assets/img/verifica.png';
import iconEdit from 'assets/img/icon_edit.svg';
import checkClean from 'assets/img/check-clean-icon.svg';
import deleteIcon from 'assets/img/delete.svg';
import { transformForSelect } from 'util/transformHelpers';
import { priceFormat } from 'util/prices';
import IMG_DEFAULT_PRODUCT from 'assets/img/default_product.png';
import { Link, useRouteMatch } from 'react-router-dom';
import { showErrorResponseModal } from 'store/actions/commons';
import { GIFT_PRODUCT_TYPES, MODES } from './config';
import styles from './styles.module.scss';
import { setterDefaultImages } from '../../../../util/util';

const GiftItem = ({
  item,
  onAddGift = _noop,
  onDeleteGift = _noop,
  onUpdateGift = _noop,
  onClickGift = _noop,
  onCancelScan = _noop,
  statusTable,
  mode = 'pick',
  quantity = 0,
  selected,
  type = GIFT_PRODUCT_TYPES.MEDIUM,
  id,
  className = '',
  onlyView = false,
  onCloseSuccessMessage = _noop,
  showBigPrice = true,
  controlsClassName = '',
  productDetailsClassName = '',
  bigRenderClassName = '',
  listClassName = '',
  showRating = true,
  showSuccessModal = false,
  giftTableId,
  showAnotherScan = false,
  sku,
  wantedSize = false,
  addGifts,
  showAllImages = true,
  callFrom = '', 
  dispatch
}) => {
  const [add, setAdd] = useState(!selected);
  const [itemMode, setItemMode] = useState(mode);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedReview, setSelectedReview] = useState({});
  const { isMobile } = useWindowSize({ largeMobile: true })[1];

  const inputName = useMemo(() => `${id}_product`, [id]);
  
  const [field, , helpers] = useField({ name: inputName });
  
  const { values } = useFormikContext();
  const { color, size } = values;
  wantedSize ? (values.size = wantedSize) : null;

  const isBig = type === GIFT_PRODUCT_TYPES.BIG;
  const isMinimalist = type === GIFT_PRODUCT_TYPES.MINIMALIST;
  const hasGuestMode = mode === MODES.GUEST;
  const hasListType = type === GIFT_PRODUCT_TYPES.LIST;
  const isBigDetail = type === GIFT_PRODUCT_TYPES.BIG_DETAILS;
  const isMobileDetail = type === GIFT_PRODUCT_TYPES.MOBILE_DETAILS;
  const hasEditMode = itemMode === MODES.EDIT;

  const isSoldOut = item.status === false || item.stock === 0;
  const hasSizes = item.size_color?.length ? item.size_color[0].hasOwnProperty('sizes') : undefined;
  values.size = !hasSizes && !wantedSize ? true : values.size;

  let error = false;

  const matchBuy = useRouteMatch({
    path: '/buy-gifts/:tableId/buy',
    exact: true,
  });

  const matchMyTable = useRouteMatch({
    path: '/my-table',
    exact: true,
  });

  const updateGiftValue = useCallback(
    (evt, defaultQuantity = 0) => {
      const gift = {
        ...item,
        quantity: Number(evt?.target?.value || field.value) || defaultQuantity,
      };

      helpers.setValue(gift.quantity);

      return gift;
    },
    [item, field, hasGuestMode, helpers]
  );

  const deleteItem = useCallback(() => {
    onDeleteGift(item).then(response => {
      response && helpers.setValue(0);
      setAdd(!!response);
    });
  }, [helpers, onDeleteGift, item, setAdd]);

  const addItemFromCache = () => {
    console.log('Enter to addItemFromCache');
    let gift_storage = window.localStorage.getItem('gift_storage');
    gift_storage = JSON.parse(gift_storage);
    const {defaultValue} = gift_storage;    
    const {currentQuantity} = gift_storage;  
    const {isCero} = gift_storage;
    const {gift} = gift_storage;

    if (isCero && !defaultValue) {
      helpers.setValue(1);
      return;
    }
    // console.log('onAddGift: ', onAddGift);
    onAddGift(gift).then(response => {
      error = !response;
      (!matchBuy && !matchMyTable) && setAdd(!response);
      if (response) {
        localStorage.setItem('gift_storage', '{}');
        setSelectedReview({});
        setShowModalAdd(true);
        return;
      }
      helpers.setValue(currentQuantity);
    });    
  }

  const addItem = useCallback(
    (evt, defaultValue = 1) => {
      console.log('Entrando a addItem:',evt,'--',defaultValue);
      window.localStorage.setItem('product_id', item.id);
      
      const gift_storage = {};
      gift_storage.defaultValue = defaultValue;
      
      const currentQuantity = item.quantity;
      gift_storage.currentQuantity = item.quantity;
      
      const value = Number(evt.target.value);
      gift_storage.value = Number(evt.target.value);
      
      const isCero = value === 0;
      gift_storage.isCero = isCero;

      const gift = updateGiftValue(
        evt,
        isCero && !defaultValue ? 0 : defaultValue || 1
      );
      gift_storage.gift = gift;
      window.localStorage.setItem('gift_storage',JSON.stringify(gift_storage));

      //  console.log(window.location.href);
      if (isCero && !defaultValue) {
        helpers.setValue(1);
        return;
      }
      // console.log('onAddGift: ', onAddGift);
      onAddGift(gift).then(response => {
        error = !response;
        (!matchBuy && !matchMyTable) && setAdd(!response);
        if (response) {
          window.localStorage.setItem('gift_storage', '{}');
          setSelectedReview({});
          setShowModalAdd(true);
          return;
        }
        helpers.setValue(currentQuantity);
      });
    },
    [onAddGift, updateGiftValue, deleteItem]
  );

  const changeQuantityItem = (evt, defaultValue = 1) => {
    console.log('Entrando a changeQuantityItem:',evt,'--',defaultValue, item.sku, item.quantity_required, item.quantity);
      const newQuantity = Number(evt.target.value);
      const isCero = newQuantity === 0;
      const quantity_required = (item.quantity_required>0)?item.quantity_required:1;
      
      if(!isCero){
        if(newQuantity > quantity_required){
          dispatch(showErrorResponseModal(`Solo puedes agregar ${quantity_required} producto${(quantity_required>1)?'s':''}`));
          return ;
        }
        if(newQuantity > item.stock){
          dispatch(showErrorResponseModal(`Solo hay ${item.stock} productos disponible${(item.stock>1)?'s':''}`));
          return ;
        }
      }
      const gift = updateGiftValue(
        evt,
        isCero && !defaultValue ? 0 : defaultValue || 1
      );

      if (isCero && !defaultValue) {
        helpers.setValue(1);
        return;
      }
      onUpdateGift(gift).
      then(response => {
        error = !response;
        console.log('response----: ', response, error);
        (!matchBuy && !matchMyTable) && setAdd(!response);
        if (response) {
          setSelectedReview({});
          setShowModalAdd(true);
          helpers.setValue(newQuantity);
          return;
        }
        helpers.setValue(item.quantity);
    });
  };

  const clickItem = useCallback(() => {
    onClickGift(item);
  }, [onClickGift]);

  const updateItem = useCallback(
    (evt) => {
      const gift = updateGiftValue(evt);
      onUpdateGift(gift);
      setAdd(false);
      setItemMode(mode);
    },
    [onUpdateGift, updateGiftValue, mode]
  );

  const handleAcceptEdition = () => {
    setAdd(true);
    updateItem();
  };

  const handleEdit = () => {
    setItemMode(MODES.EDIT);
  };

  const handleClickAdd = (product, size, color = false) => {
    let variant = size;
    if (color) {
      let sizeData = [];
      const colorData = product.size_color.filter(v => v.color === color);
      if (size === true)
        sizeData.push({ variant: colorData[0].variant });
      else
        sizeData = colorData[0].sizes.filter(v => v.size === size);
      variant = sizeData.length ? sizeData[0].variant : size;
    }
    const gift = {
      ...product,
      quantity: 1,
      variant,
    };
    onAddGift(gift);
    setShowModalAdd(true);
  };

  const handleClose = useCallback(() => {
    window.localStorage.removeItem('product_id');
    setShowModalAdd(false);
    onCloseSuccessMessage();
    if (onCancelScan) onCancelScan();
  }, [onCloseSuccessMessage]);

  const handleCloseModal = useCallback(() => {
    onCancelScan();
  }, [onCancelScan]);

  const setDefaultValueSelect = (type) => {
    let value = null;
    if (sku) {
      const data = item.size_color
        .map((c) => {
          const {color} = c;
          const variant = c.sizes.filter(
            (s) => s.variant.toString() === sku.toString()
          );
          return variant.length ? { color, variant: variant[0].variant } : null;
        })
        .filter((notnull) => notnull);
      value = data.length ? data[0][type] : null;
    }
    return value;
  };

  useEffect(() => {
    !error && setAdd(!selected);
  }, [selected]);

  useEffect(() => {
    helpers.setValue(quantity);
  }, [quantity]);

  useEffect(() => {
    if (onUpdateGift && color !== undefined && size !== undefined) {
      onUpdateGift({ ...item, color, size });
    }

    return () => {
      values.hasOwnProperty('color') ? delete values.color : null;
      values.hasOwnProperty('size') ? delete values.size : null;
    };
  }, [color, size]);

  useEffect(() => {
    if(window.localStorage.hasOwnProperty('gift_storage')){
      const gift_storage = JSON.parse(window.localStorage.getItem('gift_storage'));
      if(gift_storage.hasOwnProperty('gift')){
        if(item.id === gift_storage.gift.id){
          addItemFromCache();
        }
      }
    }    
    // console.log('item---: ', item);
  }, [item]);

  const showActions = useMemo(() => {
    const LIST_OF_ACTIONS = ['pick', 'edit', 'guest'];
    return LIST_OF_ACTIONS.indexOf(itemMode) !== -1;
  }, [itemMode]);

  const CLASS_BY_TYPE = {
    [GIFT_PRODUCT_TYPES.MEDIUM]: `${styles.GiftItem}`,
    [GIFT_PRODUCT_TYPES.BIG]: `${styles.GiftItemBig} m-0`,
    [GIFT_PRODUCT_TYPES.BIG_DETAILS]: `${styles.giftBigDetails}`,
    [GIFT_PRODUCT_TYPES.MOBILE_DETAILS]: `${styles.giftMobileDetails}`,
    [GIFT_PRODUCT_TYPES.LIST]: styles.giftList,
  };
  const price = priceFormat(item.price);
  const totalPrice = priceFormat(item.price * (item.quantity || 1));
  const priceWithoutDiscount = priceFormat(item.msrp);

  const onlyList = itemMode === 'list';
  const onlyEdit = onlyList || hasEditMode;
  
  
  /* Bloque de descuento en card de producto */
  const discountRender = (
    <>
      {/* <p>discountRender_ </p> */}
      {(addGifts || !isSoldOut) && item.c_descuento > 0 && (
        <div className={styles.discount}>-{item.c_descuento}%</div>
      )}
    </>
  );

  /* Bloque de agotado en card de producto */
  const soldOutRender = (
    <>
      {/* <p>soldOutRender_1</p> */}
      {isSoldOut /* && !addGifts */ && <div className={
        classNames(
          styles.soldOut,
          hasListType ? styles.soldOutList : ''
        )}
        style={{
            marginLeft: '0px',
          }}
          > Agotado</div>
      }
    </>
  );

  /* Bloque de agotado en card de producto */
  const editRender = (
    <>
      {/* <p>editRender_1</p> */}
      {itemMode === 'list' && statusTable === 'Open' && (
        <button
          onClick={handleEdit}
          className={styles.widgetTopLeftEdit}
          type="button"
        >
          <img alt="Editar" src={iconEdit} />
        </button>
      )}
    </>
  );
  const [images, setImages] = useState([]);
  async function setterImages() {
    const res = await setterDefaultImages(item.images);
    setImages(res);
  }
  useEffect(() => {
    if (item.images) {
      setterImages().then();
    }
  }, [item.images]);
  
  /* Bloque de imagen en card de producto */
  const productImageRender = (
    <div
      className={classNames(
        isMinimalist ? '' : isBig
          ? classNames(styles.imgcontainerBig, item.c_descuento > 0 && 'ml-2')
          : classNames(
              isBigDetail ? styles.imgcontainerBigDetail : styles.imgcontainer
            ),
        hasGuestMode && 'mb-1'
      )}
    >
    {/* <p>productImageRender_ </p> */}
    {
      isBigDetail && showAllImages ? (
        <ImageGallery />
      ) : (
        isMobileDetail && showAllImages ? (
          <ImageGallery items={images || []} showBullets showFullscreenButton={false} showThumbnails={false} bulletClass="image-gallery-bullets" />
        ) : (
          <div
            onClick={clickItem}
            onKeyDown={clickItem}
            tabIndex={0}
            role="button"
          >
            <img
              onError={(err) => {
                err.target.setAttribute('src', IMG_DEFAULT_PRODUCT);
                err.target.setAttribute('style', `width: ${isMinimalist ? '70px' : '100px'}`);
              }}
              src={item.image}
              loading="lazy"
              alt="Imagen"
              style={{ width: isMinimalist ? '70px' : '' }}
            />
          </div>
        )
      )
    }
    </div>
  );

  /* Bloque de titulo y al parecer cantidad en card de producto */
  const titleRender = (
    <p className={`${styles.description} ${isBig ? 'h6 pr-1' : ''}`}>
      {/* <p>titleRender_ </p> */}
      {item.title}
      {isMinimalist && <span className={styles.totalQuantity}>({item.quantity})</span>}
    </p>
  );

  /* Bloque de Description en card de producto */
  const bigDetailsTitleRender = (
    <>
      {/* <p>bigDetailsTitleRender_1</p> */}
      <p
        className={`${styles.description} ${isBig ? 'h6 pr-1' : ''}`}
        dangerouslySetInnerHTML={{ __html: item.title }}
      />
    </>
  );

  const validationReviews = item?.review || item?.reviews;
  /* Bloque de reviews en card de producto */
  const reviewsRankingRender = showRating && validationReviews && (
    <div className={styles.reviews}>
      {/* <p>reviewsRankingRender_ </p> */}
      <Rating
        initialRating={
          item?.reviews?.score ? item?.reviews?.score : item?.review
        }
        emptySymbol="fa fa-star-o fa-lg"
        fullSymbol="fa fa-star fa-lg"
        readonly
      />
      (
      {item?.reviews?.total_reviews
        ? item?.reviews?.total_reviews
        : item?.total_review}
      )
    </div>
  );

  /* Bloque de precio en card de producto */
  const priceRender = (
    <>
      {/* <p>priceRender_ </p> */}
      {item.price !== item.msrp && (
        <p className={styles.priceInactive} style={{
          fontSize: !isMobile?'1rem':'0.8rem',
        }} > ${priceWithoutDiscount} {isMobile && ('MXM')}</p>
      )}
      <p className={styles.priceActive}>${price} MXN</p>
    </>
  );


  // - aqui
  const renderInput = (
    <div className={styles.inputSize}>
      {/* <p>renderInput_ </p> */}
      <Input
        disabled={isSoldOut /* && !addGifts */}
        onChange={(evt) => addItem(evt, null)}
        type="number"
        min={1}
        max={item.stock}
        step={1}
        name={inputName}
        containerClassName={classNames(
          type === GIFT_PRODUCT_TYPES.MEDIUM && 'pl-0'
        )}
        groupClassName={classNames(hasListType && styles.priceInput)}
      />
    </div>
  );

  const renderInputQuantityProductsCart = (
    <>
      {/* <p>renderInputQuantityProductsCart_ </p> */}
      <ControltQuantity
        label="Cantidad"
        onChange={(evt) => changeQuantityItem(evt)}
        type="number"
        min={1}
        max={item.stock + 1}
        step={1}
        name={inputName}
      />
    </>
    
  );

  const bigPriceRender = isBig && (
    <p
      className={classNames(
        'text-primary font-weight-bold',
        isMobile ? 'h4' : 'h6'
      )}
    >{`$${totalPrice} MXN`}</p>
  );

  const controlsRender = !onlyView && (
    <div
      className={
        onlyEdit
          ? classNames(
              isBig ? styles.controlsBig : styles.controls,
              hasGuestMode && 'mt-0',
              controlsClassName
            )
          : isBig && classNames('d-flex align-items-center')
      }
    >
      {showActions ? (
        <div className={classNames(isBig && 'd-flex align-items-center')}>
          <div className={classNames(styles.btnMobile, isBig && 'mr-3 ml-1')}>
            {!add && !hasGuestMode && renderInput}

            {showBigPrice && (
              <div className="d-none d-md-block">{bigPriceRender}</div>
            )}

            {hasEditMode && !hasGuestMode && (
              <div className="mt-0 ml-2">
                <button
                  onClick={handleAcceptEdition}
                  type="button"
                  className={styles.cartadd}
                >
                  <img src={checkClean} alt="Aceptar edición" />
                </button>
              </div>
            )}
          </div>

          {add ? (
            <div className="d-flex justify-content-center align-items-center">
              <Button
                id={item?.id}
                block
                onClick={addItem}
                disabled={isSoldOut /* && !addGifts */}
                type="button"
                className={`${
                  hasGuestMode ? styles.cartaddGuest : styles.cartadd
                } primaryButton p-0`}
              >
                {hasGuestMode ? 'Regalar' : 'Agregar'}
              </Button>
            </div>
          ) : !item.is_default ? (
            <div className="d-flex justify-content-center align-items-center">
              
              {isBig ? (
                <button
                  id={item?.id}
                  onClick={deleteItem}
                  type="button"
                  className={classNames(
                    hasGuestMode ? styles.cartdeleteGuest : styles.cartdelete,
                    isBig && styles.rounded,
                    'primaryButton p-0'
                  )}
                >
                  <img src={deleteIcon} alt="Eliminar" />
                </button>
              ) : (
                <Button
                  id={item?.id}
                  block
                  variant="secondary"
                  onClick={deleteItem}
                  type="button"
                  className={classNames(
                    hasGuestMode ? styles.cartdeleteGuest : styles.cartdelete,
                    isBig && 'mt-2',
                    'primaryButton p-0'
                  )}
                >
                  Eliminar
                </Button>
              )}
              
            </div>
          ) : null}
        </div>
      ) : null}

      {itemMode === 'list' && (
        <p
          className={`table_breadcrumb ${styles.count} ${
            item.gifted === item.quantity ? 'complete' : ''
          }`}
        >
          {item.gifted} de {quantity}
        </p>
      )}
    </div>
  );


  const controlsDeleteRenderMobile = !onlyView &&  (
    <>
      {showActions ? (
        <div className="d-flex justify-content-center align-items-center">
            <Button
              onClick={deleteItem}
              style={{
              backgroundColor: '#fff',
              color: 'rgb(180, 175, 175)',
              fontSize: '0.9rem',
              fontWeight: 'normal',
              border: 'none',
              borderRadius: '0px',
              boxShadow: 'none',
              minHeight: '0px',
              padding: '0px',
            }}>
                <i className='fa fa-trash'/> Eliminar
            </Button>
          </div>
      ) : null}
    </>
  );

  const containerClassName = classNames(
    CLASS_BY_TYPE[type],
    className,
    isSoldOut /* && !addGifts */ ? styles.soldOutItem : ''
  );

  /* Bloque de card normal en cards de producto */
  const mediumRender = (
    <>
      <div className=" d-flex justify-content-center">
        {discountRender}
        {soldOutRender}

        {editRender}
      </div>
      <div>
        {productImageRender}
        {titleRender}
      </div>
      <div>{reviewsRankingRender}</div>
      <div>{priceRender}</div>
      <div>{controlsRender}</div>
    </>
  );

  const bigRender = (
    <>
      <div
        className={classNames(
          'd-none d-md-flex',
          bigRenderClassName,
          isBig && styles.widthMax
        )}
      >
        {discountRender}
        {soldOutRender}
        {productImageRender}

        <div
          className={`${styles.productDetails} d-flex flex-column justify-content-center ${productDetailsClassName}`}
        >
          {titleRender}
          {reviewsRankingRender}
        </div>

        <div className="d-flex flex-column justify-content-center">
          {priceRender}
        </div>

        {isBig && (
          <div className={classNames(isBig && styles.renderBigInput)}>
            {renderInput}
          </div>
        )}

        {controlsRender}
      </div>

      <div className={`${styles.bigMobile} d-flex d-md-none`}>
        {discountRender}
        {productImageRender}

        <div className={styles.GiftItemBigMobile}>
          <div
            className={`${styles.productDetails} d-flex flex-column justify-content-center`}
          >
            {titleRender}
            {reviewsRankingRender}
          </div>
          {onlyView ? (
            <div className="mt-3 h6">{priceRender}</div>
          ) : (
            <div className={`${styles.controls} d-flex`}>
              {isBig && renderInput}
              {controlsRender}
            </div>
          )}
          {!onlyView && <div className={styles.price}>{bigPriceRender}</div>}
        </div>
      </div>
    </>
  );

  const bigDetailsRender = (
    <>
      {discountRender}
      {soldOutRender}
      {productImageRender}

      <div className={`${styles.details} pl-md-5`}>
        <div
          className={`${styles.productDetails} d-flex flex-column justify-content-center`}
        >
          {bigDetailsTitleRender}
          {reviewsRankingRender}
        </div>
        <div className={styles.price}>{priceRender}</div>

        {item.size_color &&
          item.stock &&
          item.status &&
          Array.isArray(item.size_color) &&
          item.size_color.length > 0 && (
            <Row>
              <Col xs={6} className="px-0">
                <Select
                  label="Color"
                  name="color"
                  options={transformForSelect(
                    [
                      ...new Set(
                        item.size_color.map((itm) => {
                          const result = itm.sizes?.length ? itm.sizes.map((size) =>
                            +size.stock > 0 ? size : null
                          ).filter((notnull) => notnull)
                          : itm.stock ? [{ size: 'unica', variant: itm.variant, stock: itm.stock }] : null;
                          return result[0] ? itm : null;
                        })
                      ),
                    ].filter((notnull) => notnull) || [],
                    'color',
                    'color'
                  )}
                  defaultValue={setDefaultValueSelect('color')}
                />
              </Col>
              { hasSizes ? 
              <Col xs={6} className="px-0">
                <Select
                  label="Tallas"
                  name="size"
                  options={transformForSelect(
                    item.size_color
                      .find((sizeColor) => sizeColor.color === values.color)
                      ?.sizes?.filter((sizeItem) => sizeItem.stock > 0) || [],
                    'variant',
                    'size'
                  )}
                  defaultValue={setDefaultValueSelect('variant')}
                />
              </Col>
              : null }
            </Row>
          )}
        <div
          dangerouslySetInnerHTML={{ __html: item.description }}
          className={styles.description}
        />

        <div className={styles.actions ? 'row' : ''}>
          {showAnotherScan ? (
            <Button
              clickableRow
              onClick={handleCloseModal} 
              className="col-7 btn btn-secondary"
            >
              Escanear otro producto
            </Button>
          ) : null}
          <Button
            block
            disabled={
              (/*! addGifts && */ isSoldOut) ||
              (item?.size_color?.length && (!values.color || !values.size))
            }
            type="button"
            className={showAnotherScan ? 'col-5' : 'col-12'}
            variant={hasGuestMode ? (add ? 'primary' : 'secondary') : 'primary'}
            onClick={() =>
              hasGuestMode
                ? add
                  ? handleClickAdd(item, values.size)
                  : deleteItem()
                : handleClickAdd(item, values.size, values.color)
            }
          >
            {hasGuestMode ? (add ? 'Regalar' : 'Eliminar') : 'Agregar'}
          </Button>
        </div>
      </div>
    </>
  );

  const priceRenderMobile = (
    <>
    <div className={styles.tagContainer}>
        <span className={styles.tagInfo} style={{fontSize: '0.8rem'}}>
            Vendido por <a href="">{item?.store?.name}</a> 
        </span>
        <span className={styles.tagInfo} style={{fontSize: '0.8rem'}}>
            SKU {item?.ean}
        </span>
    </div>

    <p className={styles.tagInfo} style={{fontSize: '0.8rem'}}>   
        Marca {item?.brand}
    </p>
    {reviewsRankingRender}
     <span className={styles.priceActiveMobile}>${price} MXN</span>
      {item?.price !== item?.msrp && (
        <span className={styles.priceInactive} style={{
          fontSize: !isMobile?'1rem':'0.8rem',
        }} > ${priceWithoutDiscount} {!isMobile && ('MXM')}</span>
      )}
      {(addGifts || !isSoldOut) && item.c_descuento > 0 && (
        <span className="badge bg-success text-white">-{item.c_descuento}%</span>
      )}
      <hr/>
    </>
  );

  const mobileDetailsTitleRender = (
    <p
      className={`${styles.title} h6 pr-1 `}
      dangerouslySetInnerHTML={{ __html: item.title }}
    />
  );

  const mobileDetailsRender = (
    <div className={styles.container} style={{ paddingLeft: '2.5rem', paddingRight: '2.5rem', paddingBlockEnd: '1rem'}}>
      
      {soldOutRender}
      {productImageRender}
      <div className={`${styles.details} pl-md-5`}>
        <div
          className={`${styles.productDetails} d-flex flex-column justify-content-center`}
        >
          {mobileDetailsTitleRender}
        </div>
        <div className={styles.price}>{priceRenderMobile}</div>
        {item.size_color &&
          item.stock &&
          item.status &&
          Array.isArray(item.size_color) &&
          item.size_color.length > 0 && (
            <Row>
              <hr/>
              <Col xs={6} className="px-0">
                <Select
                  label="Color"
                  name="color"
                  options={transformForSelect(
                    [
                      ...new Set(
                        item.size_color.map((itm) => {
                          const result = itm.sizes?.length ? itm.sizes.map((size) =>
                            +size.stock > 0 ? size : null
                          ).filter((notnull) => notnull)
                          : itm.stock ? [{ size: 'unica', variant: itm.variant, stock: itm.stock }] : null;
                          return result[0] ? itm : null;
                        })
                      ),
                    ].filter((notnull) => notnull) || [],
                    'color',
                    'color'
                  )}
                  defaultValue={setDefaultValueSelect('color')}
                />
              </Col>
              { hasSizes ? 
              <Col xs={6} className="px-0">
                <Select
                  label="Tallas"
                  name="size"
                  options={transformForSelect(
                    item.size_color
                      .find((sizeColor) => sizeColor.color === values.color)
                      ?.sizes?.filter((sizeItem) => sizeItem.stock > 0) || [],
                    'variant',
                    'size'
                  )}
                  defaultValue={setDefaultValueSelect('variant')}
                />
              </Col>
              : null }
            </Row>
          )}

        <div className={styles.actions ? styles.actions : 'row'}>
        <Button
            block
            disabled={
              (/*! addGifts && */ isSoldOut) ||
              (item?.size_color?.length && (!values.color || !values.size))
            }
            type="button"
            className={showAnotherScan ? 'col-5' : 'col-12'}
            variant={hasGuestMode ? (add ? 'primary' : 'secondary') : 'primary'}
            onClick={() =>
              hasGuestMode
                ? add
                  ? handleClickAdd(item, values.size)
                  : deleteItem()
                : handleClickAdd(item, values.size, values.color)
            }
          >
            {hasGuestMode ? (add ? 'Regalar' : 'Eliminar') : 'Agregar a Mesa de Regalos'}

            <img
              src={IMG_DEFAULT_PRODUCT}
              alt="Imagen"
              style={{ width: '30px', padding: '5px' }}
              />
          </Button>
          
          {showAnotherScan ? (
            <Button
              clickableRow
              onClick={showAnotherScan}
              className="col-7 btn btn-secondary"
            >
              Escanear otro producto
            </Button>
          ) : null}

        </div>
        <hr/>
        <div
          dangerouslySetInnerHTML={{ __html: `<h5>Descripción</h5>${  item.description}` }}
          className={styles.descriptionMobile}
        />

      </div>
    </div>
  );

  /* Bloque de lista en cards de producto */
  const listRender = (
    <div 
      className={styles.container}>
      <div className="d-flex justify-content-center">
        {discountRender}
        {soldOutRender}
        {editRender}
      </div>
      <div className="row">
        <div className="col-5">{productImageRender}</div>
        <div className="col-7 p-0 m-0 pt-3">
          <div className="row p-0 m-0">
            <div className="col-12 p-0 m-0 mb-3">
              <div>{titleRender}</div>
              <div>{reviewsRankingRender}</div>
              <div>{priceRender}</div>
            </div>
            {/* {!isMobile &&
              (<div className="col-12 pl-0">{controlsRender}</div>)              
            } */}
            <div className="col-12 pl-0">{controlsRender}</div>
          </div>
        </div>
      </div>
      {isMobile && callFrom === 'CartProductsMobile' && (
        <div className="row">
          <div className="col-12 pl-0 d-flex">
            <div className="col-6">{controlsDeleteRenderMobile}</div>
            <div className="col-6">{renderInputQuantityProductsCart}</div>
          </div>
        </div>
      )}
      
    </div>
  );

  const listMinimalist = (
    <Card className={classNames(listClassName, styles.widthCard, 'mt-2 mb-2')} from="giftCartProductsItem">
      <div className="row">
        <div className="col-4 col-md-3 d-flex align-items-center">
          {productImageRender}
        </div>
        <div className="col-8 col-md-9 p-0 m-0">
          <div className="row p-0 m-0">
            <div className="col-12 p-0 m-0">
              <div>{titleRender}</div>
              <div>{priceRender}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );

  const RENDERS_BY_TYPE = {
    [GIFT_PRODUCT_TYPES.MEDIUM]: mediumRender,
    [GIFT_PRODUCT_TYPES.BIG]: bigRender,
    [GIFT_PRODUCT_TYPES.BIG_DETAILS]: bigDetailsRender,
    [GIFT_PRODUCT_TYPES.MOBILE_DETAILS]: mobileDetailsRender,
    [GIFT_PRODUCT_TYPES.LIST]: listRender,
    [GIFT_PRODUCT_TYPES.MINIMALIST]: listMinimalist,
  };

  useEffect(()=>{
    if(type){
      // console.log('type: ',type)
    }
  },[type])

  return (
    <>
      <article className={containerClassName}>{RENDERS_BY_TYPE[type]}</article>
      {showSuccessModal && (
        <ResponseModal
          title="Artículo agregado"
          icon={successIcon}
          show={showModalAdd}
          onClose={handleClose}
          onSubmit={handleClose}
          subtitle="El producto fue agregado a la mesa de regalos"
          code={`#${giftTableId}`}
          codeClassName="text-danger text-center my-4"
          {...selectedReview}
        />
      )}
    </>
  );
};

GiftItem.propTypes = {
  item: PropTypes.object.isRequired,
  onAddGift: PropTypes.func,
  onDeleteGift: PropTypes.func,
  onUpdateGift: PropTypes.func,
  onClickGift: PropTypes.func,
  statusTable: PropTypes.string,
  mode: PropTypes.string,
  quantity: PropTypes.number,
  selected: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  type: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  onlyView: PropTypes.bool,
  onCloseSuccessMessage: PropTypes.func,
  showBigPrice: PropTypes.bool,
  controlsClassName: PropTypes.string,
  productDetailsClassName: PropTypes.string,
  bigRenderClassName: PropTypes.string,
  listClassName: PropTypes.string,
  showRating: PropTypes.bool,
  showSuccessModal: PropTypes.bool,
  giftTableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default withStore({
  mapStateToProps: (state) => ({
    statusTable: state.giftTable.giftTableInfo.data?.status,
  }),
})(GiftItem);
